// @vue/component

export default {
  name: "CallPlannerItem",

  props: {
    plannedCall: {
      type: Object,
      default: () => ({})
    },
    agentsList: {
      type: Array,
      default: () => []
    },
    isShowListForToday: {
      type: Boolean,
      default: false
    },
    isCalendar: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selectedAgent: "",
      isCalling: false,
      isAgentPopoverVisible: false,
      isRemovingItem: false,
    };
  },
  computed: {
    projectsList() {
      return this.$store.getters["client/projects/list"].records;
    },
    callProjectName() {
      return this.projectsList.filter(item => item.id === this.plannedCall.project_id)[0] || "";
    },
    agentsAbleToCall() {
      return this.agentsList.filter(el => el.massdial4call === true);
    }
  },
  methods: {
    async removeOrRestorePlannedCall() {
      this.isRemovingItem = true;
      const result = await this.$store.dispatch("callPlanner/removeOrRestorePlannedCall", {
        planned_call_uuid: this.plannedCall.uuid,
        is_deleting: !this.isCalendar ? true : this.plannedCall.active,
      });
      if (result.code === 200) {
          this.$message({
            title: "Sukces",
            message: (!this.isCalendar ? true : this.plannedCall.active) ? "Usunięto rekord z listy." : "Przywrócono rekord do listy",
            type: "success"
          });
      } else {
        this.$message({
          message: "Wystąpił bład podczas " + ((!this.isCalendar ? true : this.plannedCall.active) ? "usuwania." : "przywracania."),
          type: "error"
        });
      }
      if (this.isCalendar) this.$emit("refreshCalendar");
      await this.$store.dispatch("callPlanner/getList", { type: this.isShowListForToday ? 1 : 0 });
      await this.$store.dispatch("callPlanner/getListCount");
      this.isRemovingItem = false;
    },

    async makeCall() {
      this.isCalling = true;
      const params = {
        agent: this.selectedAgent !== "" ? this.selectedAgent : this.agentsAbleToCall[0].uuid,
        number_b: this.plannedCall.num_a
      };
      const result = await this.$store.dispatch("user/agent/makeCall", params);
      if (result) {
        this.$message({
          title: "Sukces",
          message: "Następuje próba połączenia.",
          type: "success"
        });
      } else {
        this.$message({
          message: "Wystąpił bład podczas próby połączenia.",
          type: "error"
        });
      }
      this.isAgentPopoverVisible = false;
      await this.$store.dispatch("callPlanner/updateLastCallAttempt", {
        planned_call_uuid: this.plannedCall.uuid
      });
      if (this.isCalendar) this.$emit("refreshCalendar");
      await this.$store.dispatch("callPlanner/getList", { type: this.isShowListForToday ? 1 : 0 });
      this.isCalling = false;
    }
  }
};
